import { Injectable } from "@angular/core";
import { LocalMemoryCache } from "./local-memory-cache.model";

@Injectable({
  providedIn: 'root'
})
export class LocalMemoryCacheService {
  public localStorage: LocalMemoryCache = new LocalMemoryCache();
  public sessionStorage: LocalMemoryCache = new LocalMemoryCache();
}
